import React from 'react'

import Link from 'next/link'

import Content from '@nexys/components/Content/Content'
import LazyImgwrapper from '@nexys/components/LazyImgWrapper'
import { Button, Col, Row } from 'antd'
import { ilustration } from 'constant'
// import PublicContainer from 'layouts/containers/Public'
import { Text } from 'shortcuts/Typography'

import classNames from './ComingSoon.module.scss'

const Component = () => {
  const styleContent = {
    paddingTop: 70,
    paddingBottom: 50
  }

  return (
    <Content style={{ ...styleContent }}>
      <Row className="">
        <Col
          xxl={24}
          xl={24}
          lg={24}
          md={24}
          sm={24}
          xs={24}
          className="flex justify-center pb-12"
        >
          <LazyImgwrapper>
            <img
              src={ilustration.comoingSoonIlustration}
              alt="coming-soon"
              draggable={false}
              className={classNames.img}
            />
          </LazyImgwrapper>
        </Col>
        <Col
          xxl={24}
          xl={24}
          lg={24}
          md={24}
          sm={24}
          xs={24}
          className="flex justify-center pb-2"
        >
          <Text className={classNames.title}>Coming Soon</Text>
        </Col>
        <Col
          xxl={24}
          xl={24}
          lg={24}
          md={24}
          sm={24}
          xs={24}
          className="flex justify-center pb-12"
        >
          <Text className={classNames.desc}>
            Maaf! Halaman ini sementara sedang dikerjakan!
          </Text>
        </Col>
        <Col
          xxl={24}
          xl={24}
          lg={24}
          md={24}
          sm={24}
          xs={24}
          className="flex justify-center"
        >
          <Button className={classNames.button} type="primary">
            <Link href={`/`}>
              <a> Kembali ke Home</a>
            </Link>
          </Button>
        </Col>
      </Row>
    </Content>
  )
}

function ComingSoon(props) {
  return <Component />
}

export default ComingSoon
